<template>
    <div
        class="padding7 el-card"
        v-loading="openloading"
        :element-loading-text="loadingText"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <el-form
            :model="voucherQueryModel"
            label-width="120px"
            label-position="left"
        >
            <div>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item
                            label="品牌"
                            label-width="80px"
                            :required="true"
                        >
                            <el-select
                                v-model="voucherQueryModel.brandId"
                                placeholder="选择品牌"
                                size="mini"
                                class="width100"
                                @change="brandChange"
                                filterable
                            >
                                <el-option
                                    v-for="item in brandList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="业务日期"
                            label-width="80px"
                            :required="true"
                        >
                            <el-date-picker
                                v-model="time"
                                type="daterange"
                                range-separator="-"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                align="right"
                                size="mini"
                                style="width: 100%"
                                @change="timeChange"
                                :picker-options="pickerOptions"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item
                            label="单据类型"
                            label-width="80px"
                            :required="true"
                        >
                            <el-select
                                v-model="voucherQueryModel.orderType"
                                placeholder="选择单据类型"
                                size="mini"
                                class="width100"
                                @change="orderTypeChange"
                                filterable
                                multiple
                                clearable
                                collapse-tags
                            >
                                <el-option
                                    v-for="item in ordersList"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="制单状态" label-width="80px">
                            <el-select
                                v-model="voucherQueryModel.makeOrderState"
                                placeholder="选择制单状态"
                                size="mini"
                                class="width100"
                                filterable
                            >
                                <el-option
                                    v-for="state in makeOrderStateList"
                                    :key="state.id"
                                    :label="state.name"
                                    :value="state.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="门店"
                            label-width="80px"
                            :required="true"
                        >
                            <el-select
                                v-model="voucherQueryModel.queryStoreCodes"
                                placeholder="选择门店"
                                size="mini"
                                class="width100"
                                @change="storeChange"
                                filterable
                                multiple
                                @remove-tag="removeTag"
                            >
                                <el-option
                                    label="全选"
                                    value="全选"
                                ></el-option>
                                <el-option
                                    v-for="item in orgList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="生成方式" label-width="80px">
                            <el-select
                                v-model="voucherQueryModel.groupType"
                                placeholder="选择凭证生成方式"
                                size="mini"
                                class="width100"
                                @change="accountChange"
                            >
                                <el-option
                                    v-for="item in voucherTypeList"
                                    :key="item.number"
                                    :label="item.name"
                                    :value="item.number"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="top7">
                        <el-button
                            type
                            size="mini"
                            icon="el-icon-search"
                            class="pull-left"
                            @click="SetFilters"
                            :disabled="!brandSel"
                            >过滤源数据</el-button
                        >
                        <el-button
                            type
                            size="mini"
                            icon="el-icon-search"
                            class="pull-left"
                            @click="search(false)"
                            :disabled="!storeSel"
                            >查询</el-button
                        >
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="数据在第一次拉取后已本地化缓存，若需更新数据，请使用重新拉取操作"
                            placement="top-start"
                        >
                            <el-button
                                type
                                size="mini"
                                class="pull-left"
                                icon="el-icon-download"
                                @click="search(true)"
                                :disabled="!storeSel"
                                >重新拉取</el-button
                            >
                        </el-tooltip>
                        <el-button
                            type
                            size="mini"
                            icon="el-icon-search"
                            class="pull-left right-20"
                            @click="searchmore"
                            :disabled="!!!voucherQueryModel.brandId"
                            >高级查询</el-button
                        >
                        <el-button
                            type="primary"
                            size="mini"
                            icon="el-icon-download"
                            class="pull-left"
                            @click="openDialog"
                            :disabled="!isSearchVal"
                            >生成凭证</el-button
                        >
                    </el-col>
                </el-row>
            </div>
        </el-form>
        <span style="color: red; font-size: 20px">注:默认全选 无需勾选</span>
        <el-table
            :data="tableData"
            size="mini"
            style="width: 100%"
            border
            ref="tableData"
            :row-key="getRowKeys"
            show-summary
            :summary-method="getSummaries"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column prop="billNO" label="单据号"></el-table-column>
            <el-table-column label="业务日期">
                <template slot-scope="scope">
                    <span
                        :class="scope.row.color"
                        style="margin-right: 10px"
                    ></span>
                    {{ dateFormat(scope.row.busDate) }}
                </template>
            </el-table-column>
            <el-table-column prop="billType" label="单据类型"></el-table-column>
            <el-table-column prop="shopName" label="组织名称"></el-table-column>
            <el-table-column
                prop="otherSideName"
                label="对方机构"
            ></el-table-column>
            <el-table-column
                prop="supplierName"
                label="供应商"
            ></el-table-column>
            <el-table-column
                prop="totalCostMoney"
                label="非税成本"
            ></el-table-column>
            <el-table-column
                prop="totalTaxCostmoney"
                label="含税成本"
            ></el-table-column>

            <el-table-column
                prop="totalTaxSalesmoney"
                label="含税销售金额"
            ></el-table-column>
            <el-table-column
                prop="totalSalesmoney"
                label="非税销售金额"
            ></el-table-column>
        </el-table>
        <pagerBar
            ref="refPagerBar"
            :apiURL="VoucherDataApi"
            :GetData="getTableData"
            :queryParam="queryParam"
            :isInit="false"
            :errorFunc="errorHandler"
        ></pagerBar>
        <step ref="voucherCreateStep"></step>

        <!-- <targetStore ref="targetStore"></targetStore> -->
        <el-dialog
            width="70%"
            title="高级查询"
            :visible.sync="searchMoreVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="true"
        >
            <el-tabs v-model="currentSearch" @tab-click="tabpanechange">
                <el-tab-pane
                    v-for="item in searchMoreList"
                    :label="item.label"
                    :name="item.id + ''"
                >
                    <el-form
                        :model="item"
                        label-width="120px"
                        label-position="left"
                    >
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="单据号" label-width="70px">
                                    <el-input
                                        v-model="item.billNo"
                                        size="mini"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                    label="业务日期"
                                    label-width="70px"
                                >
                                    <el-date-picker
                                        v-model="item.busDate"
                                        type="daterange"
                                        range-separator="-"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        align="right"
                                        size="mini"
                                        style="width: 100%"
                                        :picker-options="pickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item
                                    label="单据类型"
                                    label-width="70px"
                                >
                                    <el-select
                                        @change="billTypeChange"
                                        v-model="item.billType"
                                        placeholder="选择单据类型"
                                        size="mini"
                                        class="width100"
                                        filterable
                                        multiple
                                        clearable
                                        collapse-tags
                                    >
                                        <el-option
                                            v-for="item in ordersList"
                                            :key="item.code"
                                            :label="item.name"
                                            :value="item.code"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <!-- <el-col :span="6">
                <el-form-item label="单据状态" label-width="68px">
                  <el-select
                    v-model="item.orderState"
                    placeholder="选择单据状态"
                    size="mini"
                    class="width100"
                    filterable
                  >
                    <el-option
                      v-for="state in stateList"
                      :key="state.id"
                      :label="state.name"
                      :value="state.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->

                            <el-col :span="6">
                                <el-form-item
                                    label="制单状态"
                                    label-width="68px"
                                >
                                    <el-select
                                        v-model="item.makeOrderState"
                                        placeholder="选择单据状态"
                                        size="mini"
                                        class="width100"
                                        filterable
                                    >
                                        <el-option
                                            v-for="state in makeOrderStateList"
                                            :key="state.id"
                                            :label="state.name"
                                            :value="state.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="组织" label-width="70px">
                                    <el-select
                                        clearable
                                        filterable
                                        v-model="item.orgName"
                                        placeholder="选择组织机构"
                                        size="mini"
                                        class="width100"
                                    >
                                        <el-option
                                            v-for="item in orgList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                    label="对方机构"
                                    label-width="70px"
                                >
                                    <el-input
                                        v-model="item.otherSideName"
                                        size="mini"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item
                                    label="方案名称"
                                    label-width="70px"
                                >
                                    <el-input
                                        v-model="item.name"
                                        size="mini"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="0px">
                                    <el-button
                                        icon="el-icon-check"
                                        type="primary"
                                        size="mini"
                                        class
                                        @click="savePlan(item)"
                                        >保存方案</el-button
                                    >
                                    <el-button
                                        icon="el-icon-delete"
                                        type="danger"
                                        size="mini"
                                        @click="delPlan(item.id)"
                                        v-if="item.id != 0"
                                        >删除方案</el-button
                                    >
                                    <el-button
                                        icon="el-icon-search"
                                        type="primary"
                                        size="mini"
                                        @click="searchPlan(item)"
                                        >查询</el-button
                                    >
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
        <el-dialog
            width="50%"
            :visible.sync="SetFiltersVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="true"
            title="过滤源数据"
        >
            <div
                class="clearfix"
                style="padding-bottom: 6px; margin-top: -25px"
            >
                <span style="color: red"
                    >注:此处设置的条件为过滤不生成凭证的单据，后台默认已过滤
                    出入库金额、含税金额、含税配送金额全为0的单据</span
                >
                <span>
                    <el-button
                        class="pull-right"
                        type="primary"
                        icon="el-icon-check"
                        size="mini"
                        @click="saveFilterData"
                        >保存</el-button
                    >
                    <el-button
                        class="pull-right right-20"
                        icon="el-icon-plus"
                        size="mini"
                        @click="addFilters()"
                        >新增行</el-button
                    >
                </span>
            </div>
            <el-row :gutter="20">
                <el-table
                    :data="filtersData"
                    size="mini"
                    ref="filtersDetail"
                    border
                    highlight-current-row
                    highlight-hover-row
                    class="toggletable"
                >
                    <el-table-column
                        type="index"
                        label="序号"
                        width="50"
                        fixed
                    ></el-table-column>
                    <el-table-column
                        label="删除"
                        width="70"
                        fixed
                        style="margin-left: -8px"
                    >
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                icon="el-icon-delete"
                                size="mini"
                                @click="deleteRow(scope.$index, scope.row._id)"
                            ></el-button>
                        </template>
                    </el-table-column>
                    <template v-for="(item, index) in fieldList">
                        <el-table-column
                            :label="item.fieldName + '字段'"
                            min-width="160"
                        >
                            <template slot-scope="scope">
                                <el-select
                                    v-model="scope.row[item.fieldName + '字段']"
                                    placeholder="请选择字段"
                                    size="mini"
                                    class="width120 floatleft"
                                    clearable
                                >
                                    <el-option value="编码">编码</el-option>
                                    <el-option value="名称">名称</el-option>
                                </el-select>
                                <el-select
                                    v-model="scope.row[item.fieldName + '操作']"
                                    placeholder="请选择操作"
                                    size="mini"
                                    class="width120 floatleft"
                                    clearable
                                >
                                    <el-option
                                        v-for="item in OperTypeList"
                                        :key="item"
                                        :label="item"
                                        :value="item"
                                    ></el-option>
                                </el-select>
                                <el-input
                                    v-model="scope.row[item.fieldName + '值']"
                                    size="mini"
                                    class="width120 floatleft"
                                    placeholder="请输入值"
                                ></el-input>
                                <span
                                    v-if="
                                        scope.row[item.fieldName + '字段'] &&
                                        scope.row[item.fieldName + '操作'] &&
                                        scope.row[item.fieldName + '值']
                                    "
                                    >{{ item.fieldName }}：{{
                                        scope.row[item.fieldName + '字段']
                                    }}
                                    ->
                                    {{ scope.row[item.fieldName + '操作'] }} ->
                                    {{ scope.row[item.fieldName + '值'] }}</span
                                >
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import config from '@/common/config.js'
import pagerBar from '@/views/pager/pagerBar'
import AjaxHelper from '@/common/js/AjaxHelper'
import targetStore from '@/views/voucherAdmin/z5storeTransfer'
import VXETable from '../../../node_modules/vxe-table/'
import step from './voucherCreateCloudOrZ5Step'

export default {
    components: {
        step,
        pagerBar
    },
    data() {
        return {
            orgList: [],
            GetStoreListUrl:
                config.BASE_Middle_API + 'VoucherCreate/GetZ5ShopListForSelect',
            loadingText: '加载中',
            openloading: false,
            filtersData: [],
            SetFiltersVisible: false,
            isSearchVal: false,
            isVoucherCreate: false,
            queryParam: {},
            brandSel: false,
            storeSel: false,
            CurrnetMID: 0,
            DeleteFiltersUrl:
                config.BASE_Middle_API + 'VoucherCreate/DeleteFilterData',
            SaveFiltersUrl:
                config.BASE_Middle_API + 'VoucherCreate/CreateOrUpdateList',
            GetFiltersDataUrl:
                config.BASE_Middle_API + 'VoucherCreate/GetFiltersData',
            CloudDataUrl: config.BASE_Middle_API + 'CloudShopInfo',
            VoucherCreateApi: config.BASE_Middle_API + 'VoucherCreate',
            VoucherDataApi:
                config.BASE_Middle_API + 'VoucherCreate/GetZ5CloudData', //获取源数据接口 需提供
            saveApi:
                config.BASE_Middle_API +
                'VoucherCreate/MutilShopsZ5CloudDataHandle',
            Visible: false,
            optionsList: [],
            moduleList: [],
            brandList: [],
            brands: [],
            storesList: [],
            stores: [],
            ordersList: [],
            tableData: [],
            accountList: [],
            voucherTypeList: [
                { number: '2', name: '按照选择日期生成一张凭证' },
                { number: '1', name: '按照单据编号生成凭证' },
                { number: '3', name: '按照对方机构生成多张凭证' }
            ],
            fieldList: [
                { fieldName: '供应商' },
                { fieldName: '客户' },
                { fieldName: '仓库' }
            ],
            fieldTypeList: ['编码', '名称'],
            OperTypeList: ['包含', '不包含', '等于', '不等于'],
            time: [
                moment().format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD')
            ],
            voucherQueryModel: {
                startTime: moment().format('YYYY-MM-DD'),
                endTime: moment().format('YYYY-MM-DD'),
                brandId: '',
                store: '',
                orderType: '',
                groupType: '2',
                orderIds: [],
                orderState: 0,
                makeOrderState: 0
            },
            isMultiOrg: false,
            selOrder: [],
            selOrderIds: [],
            multipeleSelectedIds: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '昨天',
                        onClick(picker) {
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24)
                            const end = start
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '上周',
                        onClick(picker) {
                            var now = new Date() //当前日期
                            var nowDayOfWeek = now.getDay() //今天本周的第几天
                            var nowDay = now.getDate() //当前日
                            var nowMonth = now.getMonth() //当前月
                            var nowYear = now.getYear() //当前年
                            nowYear += nowYear < 2000 ? 1900 : 0 //
                            var start = new Date(
                                nowYear,
                                nowMonth,
                                nowDay - nowDayOfWeek - 6
                            )
                            const end = new Date(
                                nowYear,
                                nowMonth,
                                nowDay - nowDayOfWeek
                            )
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '上月',
                        onClick(picker) {
                            const starttime = moment(
                                moment()
                                    .month(moment().month() - 1)
                                    .startOf('month')
                                    .valueOf()
                            ).format('YYYY-MM-DD HH:mm:ss')
                            const endtime = moment(
                                moment()
                                    .month(moment().month() - 1)
                                    .endOf('month')
                                    .valueOf()
                            ).format('YYYY-MM-DD HH:mm:ss')

                            picker.$emit('pick', [starttime, endtime])
                        }
                    },
                    {
                        text: '本月',
                        onClick: (picker) => {
                            let start = new Date(
                                moment()
                                    .startOf('month')
                                    .format('YYYY-MM-DD HH:mm:ss')
                            )
                            let end = new Date(
                                moment()
                                    .endOf('days')
                                    .format('YYYY-MM-DD HH:mm:ss')
                            )
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            )
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            },
            searchMoreVisible: false,
            currentSearch: '0 ',
            searchMoreList: [],
            searchMoreEmpty: {
                label: '高级查询',
                name: '',
                id: '0',
                billNo: '',
                busDate: [],
                billType: [],
                billBusType: [],
                otherSideName: '',
                otherWarehouseName: '',
                orgName: '',
                orderState: 0,
                makeOrderState: 0
            },
            filterModel: {},
            billBusTypeList: [],
            billBusTypeListTemp: [],

            searchDataTemp: {},
            stateList: [],
            makeOrderStateList: []
        }
    },
    props: {
        tabType: {
            type: String,
            required: true
        }
    },

    mounted() {
        this.getModules()
        this.stateList.push({ id: 0, name: '全部' })
        this.stateList.push({ id: 1, name: '已审' })
        this.stateList.push({ id: 2, name: '复审' })
        this.makeOrderStateList.push({ id: 0, name: '全部' })
        this.makeOrderStateList.push({ id: 1, name: '未制单' })
    },
    methods: {
        closeloadingHandler() {
            this.openloading = false
        },
        openloadingHandler() {
            this.openloading = true
        },
        guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
                /[xy]/g,
                function (c) {
                    var r = (Math.random() * 16) | 0,
                        v = c == 'x' ? r : (r & 0x3) | 0x8
                    return v.toString(16)
                }
            )
        },
        storeChange(val) {
            this.storeSel = true
            var end = val[val.length - 1]
            if (!val.includes('全选') && val.length === this.orgList.length) {
                val.unshift('全选')
            } else if (val.includes('全选') && val.length == 1) {
                this.orgList.map((item) => {
                    val.push(item.id)
                })
            } else if (
                val.includes('全选') &&
                val.length - 1 < this.orgList.length &&
                end == '全选'
            ) {
                val = []
                this.orgList.map((item) => {
                    val.push(item.id)
                })
                val.unshift('全选')
                // this.value = val;
            } else if (
                val.includes('全选') &&
                val.length - 1 < this.orgList.length
            ) {
                val = val.filter((item) => {
                    return item !== '全选'
                })
                // this.value = val;
            }
            // 注意，加上  this.value = val，确保勾选值同步
            this.voucherQueryModel.queryStoreCodes = val
            if (this.voucherQueryModel.orderType == '') {
                this.voucherQueryModel.groupType = '2'
                this.storeSel = false
            } else {
                this.storeSel = true
            }
        },
        removeTag(val) {
            if (val === '全选') {
                this.voucherQueryModel.queryStoreCodes = []
                this.tableData = []
            }
            if (this.voucherQueryModel.queryStoreCodes.length == 0) {
                this.isSearchVal = false
                if (this.voucherQueryModel.orderType == '') {
                    this.voucherQueryModel.groupType = '2'
                    this.storeSel = false
                } else {
                    this.storeSel = true
                }
            }
        },
        getOrgList() {
            const _this = this
            AjaxHelper.get(
                _this.GetStoreListUrl +
                    '?brandId=' +
                    _this.voucherQueryModel.brandId
            )
                .then(function (response) {
                    if (response.success) {
                        _this.orgList = response.result
                    }
                })
                .catch(function (error) {
                    _this.closeloadingHandler()
                })
        },
        getSummaries(param) {
            const { columns, data } = param
            const sums = []
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计'
                    return
                }
                if (index === 5 || index === 6) {
                    sums[index] = ''
                    return
                }
                const values = data.map((item) => Number(item[column.property]))
                if (!values.every((value) => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr)
                        if (!isNaN(value)) {
                            return prev + curr
                        } else {
                            return prev
                        }
                    }, 0)
                    sums[index] = parseFloat(sums[index]).toFixed(2)
                } else {
                    sums[index] = ''
                }
            })

            return sums
        },

        deleteRow(index, id) {
            const _this = this
            _this
                .$confirm('确定删除该明细吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                .then(() => {
                    _this.deleteInfo(index, id)
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        deleteInfo(index, id) {
            const _this = this
            let deleteEntity = {}
            deleteEntity.tempId = id
            deleteEntity.brandId = _this.voucherQueryModel.brandId
            if (id != undefined && id != null && id != '' && id != 0) {
                AjaxHelper.delete(_this.DeleteFiltersUrl, deleteEntity).then(
                    function (r) {
                        if (r.success) {
                            _this.deleteTip(index)
                        }
                    }
                )
            } else {
                _this.deleteTip(index)
            }
        },
        deleteTip(index) {
            this.$message({
                type: 'success',
                message: '删除成功!'
            })
            this.filtersData.splice(index, 1)
        },
        //保存
        saveFilterData() {
            const _this = this
            let num = 1
            _this.openloadingHandler()
            if (_this.filtersData == null || _this.filtersData.length == 0) {
                this.$notify({
                    title: '提示',
                    message: '无待保存数据',
                    position: 'bottom-right'
                })
                _this.closeloadingHandler()
                return
            }
            _this.filtersData.forEach((item) => {
                let detailParams = []
                _this.fieldList.forEach((detailParamItemBase) => {
                    if (item[detailParamItemBase.fieldName + '字段']) {
                        detailParams.push({
                            fieldName: detailParamItemBase.fieldName,
                            type: item[detailParamItemBase.fieldName + '字段'],
                            oper: item[detailParamItemBase.fieldName + '操作'],
                            value: item[detailParamItemBase.fieldName + '值']
                        })
                    }
                })
                item.tempId = item._id
                item.index = num
                item.detailParams = JSON.stringify(detailParams)
                num = num + 1
                item.brandId = _this.voucherQueryModel.brandId
                item.ModuleMark = 'Z5'
            })
            AjaxHelper.post(_this.SaveFiltersUrl, _this.filtersData)
                .then(function (response) {
                    if (response.success) {
                        _this.$notify({
                            title: '成功',
                            message: '保存成功',
                            type: 'success',
                            position: 'bottom-right'
                        })
                        _this.initFiltersData()
                        _this.closeloadingHandler()
                    }
                })
                .catch(function (error) {})
        },
        initFiltersData() {
            const _this = this
            _this.filtersData = []
            AjaxHelper.get(_this.GetFiltersDataUrl, {
                brandId: _this.voucherQueryModel.brandId,
                ModuleMark: 'Z5'
            }).then(function (response) {
                if (response.success) {
                    _this.filtersData = response.result
                    _this.setData()
                }
            })
        },
        setData() {
            const _this = this
            if (_this.filtersData != null && _this.filtersData.length > 0) {
                _this.filtersData.forEach((f) => {
                    if (f.detailParams != null && f.detailParams.length > 0) {
                        var detailParams = JSON.parse(f.detailParams)
                        detailParams.forEach((d) => {
                            f[d.fieldName] = d.fieldName
                            f[d.fieldName + '字段'] = d.type
                            f[d.fieldName + '操作'] = d.oper
                            f[d.fieldName + '值'] = d.value
                        })
                    }
                })
                _this.filtersData = JSON.parse(
                    JSON.stringify(_this.filtersData)
                )
            }
        },
        addFilters() {
            const _this = this
            _this.filtersData.push({})
        },
        ///过滤关键字
        SetFilters() {
            const _this = this
            _this.SetFiltersVisible = true
            _this.openloadingHandler()
            _this.initFiltersData()
            _this.closeloadingHandler()
        },
        fieldChange() {},
        fieldTypeChange() {},
        operTypeChange() {},

        getRowKeys(row) {
            return row.billNO
        },
        handleSelectionChange(val) {
            const _this = this
            if (_this.selOrder.length == 0) {
                _this.selOrder.push({
                    key: _this.$refs.refPagerBar.currentPage,
                    value: val
                })
            } else {
                let b = false
                _this.selOrder.forEach((item) => {
                    if (item.key == _this.$refs.refPagerBar.currentPage) {
                        b = true
                        item.value = val
                    }
                })
                if (!b) {
                    _this.selOrder.push({
                        key: _this.$refs.refPagerBar.currentPage,
                        value: val
                    })
                }
            }
        },
        // handleSelectionChange(val) {
        //   this.multipeleSelectedIds = val;
        // },
        // 选中table已有数据
        toggleSelection(rows) {
            if (rows) {
                rows.forEach((row) => {
                    this.$nextTick(() => {
                        let checked = this.tableData.find(
                            (tableRow) => tableRow.billNO === row.billNO
                        )
                        this.$refs.tableData.toggleRowSelection(checked)
                    })
                })
            } else {
                this.$refs.tableData.clearSelection()
            }
        },
        tableSelectHandler(selection, row) {
            const _this = this
            let allRows = selection.filter((item) => !!item)
            if (allRows.find((item) => item.billNO === row.billNO)) {
                _this.addRows([row])
            } else {
                _this.removeRows([row])
            }
        },
        addRows(rows) {
            const _this = this
            for (let key of rows) {
                if (
                    !_this.selOrder.find((item) => item.billNO === key.billNO)
                ) {
                    this.selOrder.push(key)
                }
            }
        },
        // 取消选中行
        removeRows(rows) {
            const _this = this
            if (_this.selOrder.length > 0) {
                for (let row of rows) {
                    _this.selOrder = _this.selOrder.filter(
                        (item) => item.billNO !== row.billNO
                    )
                }
            }
        },
        tableSelectAllHandler(selection) {
            //删除undefined 也就是表头的checkbox的数据 否则翻页全选不会取消
            selection.forEach((e, index) => {
                if (e === undefined) {
                    selection.splice(index, 1)
                }
            })
            // 如果有则是全选否则就是全取消
            if (selection.length > 0) {
                this.addRows(this.tableData)
            } else {
                this.removeRows(this.tableData)
            }
        },
        dateFormat(val) {
            return moment(val).format('YYYY-MM-DD')
        },
        timeChange(val) {
            this.voucherQueryModel.startTime = moment(val[0]).format(
                'YYYY-MM-DD'
            )
            this.voucherQueryModel.endTime = moment(val[1]).format('YYYY-MM-DD')
        },
        errorHandler() {
            this.closeloadingHandler()
        },
        search(isAgainPull) {
            const _this = this
            _this.openloadingHandler()
            _this.queryTick = _this.guid()
            cf.event.on('app.chat.messageReceived', function (message) {
                if (_this.queryTick === message.sharedMessageId) {
                    _this.loadingText = message.message
                }
            })
            let confirmData = Object.assign(
                { tick: _this.queryTick },
                _this.voucherQueryModel
            )
            _this.$refs.tableData.clearSelection()
            if (_this.voucherQueryModel.brandId == '') {
                _this.$message({
                    type: 'error',
                    position: 'bottom-right',
                    message: '请先选择品牌'
                })
                _this.closeloadingHandler()
                return
            }
            let storeIdList = []
            _this.voucherQueryModel.queryStoreCodes.forEach((t) => {
                if (t != '全选') {
                    storeIdList.push(t)
                }
            })
            confirmData.queryStoreCodes = storeIdList.join(',')
            if (
                _this.voucherQueryModel.orderType == null ||
                _this.voucherQueryModel.orderType == []
            ) {
                let orderTypeCode = []
                _this.ordersList.map((x) => {
                    orderTypeCode.push(x.code)
                })
                confirmData.billTypes = orderTypeCode.join(',')
            } else {
                confirmData.billTypes =
                    _this.voucherQueryModel.orderType.join(',')
            }
            confirmData.isAgainPull = isAgainPull
            confirmData.orderState = _this.voucherQueryModel.orderState
            confirmData.makeOrderState = _this.voucherQueryModel.makeOrderState
            confirmData.groupType = _this.voucherQueryModel.groupType
            _this.queryParam = Object.assign({}, confirmData)
            _this.searchDataTemp = {}
            _this.searchDataTemp = Object.assign({}, confirmData)
        },
        //切换方案后修改业务类型数据源
        tabpanechange(tab, event) {
            var val = []
            this.searchMoreList.map((x) => {
                if (tab.name == x.id + '') {
                    val = x.billType
                }
            })
            this.currentSearch = tab.name + ''
        },
        //选择单据类型后修改业务类型数据源
        billTypeChange(val) {
            this.tableData = []
        },

        //打开高级查询对话框
        searchmore() {
            this.pushsearchMoreEmpty()
            this.initSearchPlan()
        },
        pushsearchMoreEmpty() {
            this.searchMoreVisible = true
            this.currentSearch = '0'
            this.searchMoreList = []
            this.voucherQueryModel.queryStoreCodes = ''
            let confirmData = {
                label: '高级查询',
                name: '',
                id: '0',
                billNo: '',
                busDate: [],
                billType: [],
                billBusType: [],
                otherSideName: '',
                orderState: 0,
                makeOrderState: 0,
                orgName: '',
                branchOfficeCode: '',
                brandID: this.voucherQueryModel.brandId
            }
            let date = new Date() //获取新的时间
            //获取当前年份,并且转为字符串
            let year = date.getFullYear().toString()
            //获取当前月份，因为月份是要从0开始，此处要加1，
            //使用三元表达式，判断是否小于10，如果是的话，就在字符串前面拼接'0'
            let month =
                date.getMonth() + 1 < 10
                    ? '0' + (date.getMonth() + 1).toString()
                    : (date.getMonth() + 1).toString()
            //获取天，判断是否小于10，如果是的话，就在在字符串前面拼接'0'
            let day =
                date.getDate() < 10
                    ? '0' + date.getDate().toString()
                    : date.getDate().toString()
            //字符串拼接，将开始时间和结束时间进行拼接
            let start = year + '-' + month + '-01' //当月第一天
            let end = year + '-' + month + '-' + day //当天
            confirmData.busDate = [start, end] //将值设置给组件DatePicker 绑定的数据
            this.searchMoreEmpty = confirmData
            this.searchMoreList.push(this.searchMoreEmpty)
        },
        //获得查询方案
        initSearchPlan() {
            const _this = this
            _this.searchMoreList = []
            _this.pushsearchMoreEmpty()
            _this.$nextTick(function () {
                AjaxHelper.get(
                    _this.VoucherCreateApi +
                        '/GetSearchPlans?brandId=' +
                        _this.voucherQueryModel.brandId,
                    {
                        ModuleMark: 'Z5'
                    }
                )
                    .then(function (response) {
                        if (response.success) {
                            if (
                                response.result != null &&
                                response.result.length > 0
                            ) {
                                response.result.forEach((item) => {
                                    item.label = item.name
                                    if (item.billTypes) {
                                        item.billType =
                                            item.billTypes.split(',')
                                    }

                                    var busDate = []
                                    if (
                                        item.busDateBegin != null &&
                                        item.busDateEnd != null
                                    ) {
                                        busDate.push(
                                            new moment(
                                                item.busDateBegin
                                            ).format('YYYY-MM-DD')
                                        )
                                        busDate.push(
                                            new moment(item.busDateEnd).format(
                                                'YYYY-MM-DD'
                                            )
                                        )
                                    }
                                    item.busDate = busDate
                                    if (item.totalIncloudTaxMoneyMin == null) {
                                        item.totalIncloudTaxMoneyMin = undefined
                                    }
                                    if (item.totalIncloudTaxMoneyMax == null) {
                                        item.totalIncloudTaxMoneyMax = undefined
                                    }
                                    if (item.orderState == null) {
                                        item.ordersList = 0
                                    }
                                    _this.searchMoreList.push(item)
                                })
                            }
                        }
                    })
                    .catch(function (error) {})
            })
        },
        //删除查询方案
        delPlan(id) {
            const _this = this
            AjaxHelper.post(_this.VoucherCreateApi + '/SearchPlanDelete', {
                id: id
            })
                .then(function (response) {
                    if (response.success) {
                        _this.$notify({
                            title: '成功',
                            message: '删除成功',
                            type: 'success',
                            position: 'bottom-right'
                        })
                        _this.initSearchPlan()
                        _this.currentSearch = '0'
                    }
                })
                .catch(function (error) {
                    _this.$notify({
                        title: '提示',
                        message: error.message,
                        type: 'error',
                        position: 'bottom-right'
                    })
                })
        },
        //高级查询
        searchPlan(item) {
            const _this = this
            var b = _this.checkSearchPlan(item)
            if (b) {
                _this.searchMoreVisible = false
                _this.openloadingHandler()
                if (_this.voucherQueryModel.brandId == '') {
                    _this.$message({
                        type: 'error',
                        position: 'bottom-right',
                        message: '请先选择品牌'
                    })
                    _this.closeloadingHandler()
                    return
                }
                let confirmData = Object.assign({}, _this.voucherQueryModel)
                confirmData.storeID = 1
                confirmData.storeCode = ''
                confirmData.billNo = item.billNo
                confirmData.otherSideName = item.otherSideName
                confirmData.orderState = item.orderState
                confirmData.makeOrderState = item.makeOrderState
                confirmData.orgName = item.orgName
                //处理单据类型
                if (
                    item.billType != null &&
                    item.billType != [] &&
                    item.billType.length > 0
                ) {
                    //高级查询勾选单据类型，则页面查询同步
                    _this.voucherQueryModel.orderType = item.billType
                    confirmData.billTypes = item.billType.join(',')
                } else {
                    //高级查询不勾选单据类型，则以页面查询为准
                    if (
                        _this.voucherQueryModel.orderType == null ||
                        _this.voucherQueryModel.orderType == []
                    ) {
                        let orderTypeCode = []
                        _this.ordersList.map((x) => {
                            orderTypeCode.push(x.billTypeCode)
                        })
                        confirmData.billTypes = orderTypeCode.join(',')
                    } else {
                        confirmData.billTypes =
                            _this.voucherQueryModel.orderType.join(',')
                    }
                }
                //处理日期
                if (item.busDate != [] && item.busDate.length == 2) {
                    //高级查询处理了日期，则页面查询同步
                    _this.time = item.busDate
                    confirmData.startTime = moment(item.busDate[0]).format(
                        'YYYY-MM-DD'
                    )
                    confirmData.endTime = moment(item.busDate[1]).format(
                        'YYYY-MM-DD'
                    )
                } else {
                    confirmData.startTime = this.voucherQueryModel.startTime
                    confirmData.endTime = this.voucherQueryModel.endTime
                }
                //处理金额
                confirmData.totalIncloudTaxMoneyMin =
                    item.totalIncloudTaxMoneyMin == undefined
                        ? null
                        : item.totalIncloudTaxMoneyMin
                confirmData.totalIncloudTaxMoneyMax =
                    item.totalIncloudTaxMoneyMax == undefined
                        ? null
                        : item.totalIncloudTaxMoneyMax
                confirmData.groupType = _this.voucherQueryModel.groupType
                _this.queryParam = Object.assign({}, confirmData)
                _this.searchDataTemp = {}
                _this.searchDataTemp = Object.assign({}, confirmData)
            }
        },
        //保存查询方案
        savePlan(item) {
            const _this = this
            if (!item.name) {
                _this.$notify({
                    title: '提示',
                    message: '请输入方案名称',
                    type: 'error',
                    position: 'bottom-right'
                })
                return false
            }
            item.moduleMark = 'Z5'
            item.brandID = _this.voucherQueryModel.brandId

            var b = _this.checkSearchPlan(item)
            if (b) {
                AjaxHelper.post(
                    _this.VoucherCreateApi + '/SearchPlanCreateOrEdit',
                    item
                )
                    .then(function (response) {
                        if (response.success) {
                            _this.$notify({
                                title: '成功',
                                message: '保存成功',
                                type: 'success',
                                position: 'bottom-right'
                            })
                            _this.initSearchPlan()
                            _this.currentSearch = item.id + ''
                        }
                    })
                    .catch(function (error) {
                        _this.$notify({
                            title: '提示',
                            message: error.message,
                            type: 'error',
                            position: 'bottom-right'
                        })
                    })
            }
        },
        //检查查询方案正确性
        checkSearchPlan(item) {
            const _this = this
            var b = false
            if (item.busDate != null && item.busDate.length == 2) {
                b = true
                item.busDateBegin = moment(item.busDate[0]).format('YYYY-MM-DD')
                item.busDateEnd = moment(item.busDate[1]).format('YYYY-MM-DD')
            }
            if (item.billType != null && item.billType.length > 0) {
                b = true
                item.billTypes = item.billType.join(',')
            }
            if (item.billNo) {
                b = true
            }
            if (item.otherSideName) {
                b = true
            }
            if (item.otherWarehouseName) {
                b = true
            }
            if (item.orgName) {
                b = true
            }
            if (
                (item.totalIncloudTaxMoneyMin != undefined ||
                    item.totalIncloudTaxMoneyMax != undefined) &&
                item.totalIncloudTaxMoneyMin != item.totalIncloudTaxMoneyMax
            ) {
                b = true
            }
            if (
                item.totalIncloudTaxMoneyMin != undefined &&
                item.totalIncloudTaxMoneyMax != undefined &&
                item.totalIncloudTaxMoneyMin == item.totalIncloudTaxMoneyMax
            ) {
                _this.$notify({
                    title: '提示',
                    message: '含税金额两个值不能相同',
                    type: 'error',
                    position: 'bottom-right'
                })
                return false
            }
            if (!b) {
                _this.$notify({
                    title: '提示',
                    message: '请输入查询项',
                    type: 'error',
                    position: 'bottom-right'
                })
                return false
            }
            return b
        },
        openDialog() {
            const _this = this
            _this.selOrderIds = []
            _this.selOrder.forEach((item) => {
                if (item.value != null && item.value.length > 0) {
                    item.value.forEach((v) => {
                        _this.selOrderIds.push(v.billNO)
                    })
                }
            })
            _this.queryTick = _this.guid()
            cf.event.on('app.chat.messageReceived', function (message) {
                if (_this.queryTick === message.sharedMessageId) {
                    _this.loadingText = message.message
                }
            })
            _this.voucherQueryModel.tick = _this.queryTick
            _this.voucherQueryModel.orderIds = _this.selOrderIds
            _this.voucherQueryModel.vouchernumber =
                _this.$refs.refPagerBar.pagerTotal
            let shopList = []
            if (_this.voucherQueryModel.queryStoreCodes.length == 0) {
                if (_this.searchDataTemp.orgName) {
                    shopList.push(_this.searchDataTemp.orgName)
                } else {
                    shopList = _this.orgList
                        .map((item) => item.id)
                        .reduce((acc, curr) => acc.concat(curr), [])
                }
            } else {
                shopList = _this.voucherQueryModel.queryStoreCodes
            }
            let selectStoreList = []
            let storeNameList = []
            shopList.forEach((t) => {
                if (t != '全选') {
                    const storeItem = _this.orgList.filter((x) => x.id == t)
                    storeNameList.push(storeItem[0].name)
                    selectStoreList.push(storeItem[0].id)
                }
            })

            const confirmData = {
                brandID: _this.voucherQueryModel.brandId,
                billNo: _this.searchDataTemp.billNo,
                otherSideName: _this.searchDataTemp.otherSideName,
                otherWarehouseName: _this.searchDataTemp.otherWarehouseName,
                billBusTypes: _this.searchDataTemp.billBusTypes,
                billTypes: _this.searchDataTemp.billTypes,
                totalIncloudTaxMoneyMin:
                    _this.searchDataTemp.totalIncloudTaxMoneyMin,
                totalIncloudTaxMoneyMax:
                    _this.searchDataTemp.totalIncloudTaxMoneyMax,
                startTime: _this.searchDataTemp.startTime,
                endTime: _this.searchDataTemp.endTime,
                storeIDs: selectStoreList,
                groupType: _this.voucherQueryModel.groupType,
                orderIds: _this.voucherQueryModel.orderIds,
                orderState: _this.searchDataTemp.orderState,
                makeOrderState: _this.searchDataTemp.makeOrderState,
                orgName: _this.searchDataTemp.orgName,
                isYSYF: _this.voucherQueryModel.isYSYF,
                isSSSF: _this.voucherQueryModel.isSSSF,
                tick: _this.voucherQueryModel.tick
            }
            confirmData.storeNames = storeNameList

            var totalCount = 0
            if (_this.voucherQueryModel.orderIds.length == 0) {
                totalCount = _this.voucherQueryModel.vouchernumber
            } else {
                totalCount = _this.voucherQueryModel.orderIds.length
            }
            let orderTypeNameList = []
            let billTypeList = []
            if (
                confirmData.billTypes != '' &&
                confirmData.billTypes != null &&
                confirmData.billTypes != 'undefined'
            ) {
                billTypeList = confirmData.billTypes.split(',')
            } else {
                confirmData.billTypes = ''
            }
            billTypeList.forEach((t) => {
                const storeItem = this.ordersList.filter((x) => x.code == t)
                orderTypeNameList.push(storeItem[0].name)
            })
            confirmData.billTypeNames = orderTypeNameList

            _this.$refs.voucherCreateStep.showParams(confirmData)
            _this.$refs.voucherCreateStep.beginStep(confirmData, totalCount)
            if (confirmData.isSSSF || confirmData.isYSYF) {
                _this.$refs.voucherCreateStep.successstep1(totalCount)
                AjaxHelper.post(_this.saveApi, confirmData)
                    .then(function (response) {
                        if (response.result.isSuccess) {
                            _this.$refs.voucherCreateStep.successstep2()
                        } else {
                            _this.$refs.voucherCreateStep.failstep2(
                                response.result.voucherHandleInfos
                            )
                        }
                        _this.targetData = []
                    })
                    .catch(function (error) {
                        _this.$refs.voucherCreateStep.failstep2(error.message)
                    })
            } else {
                AjaxHelper.post(
                    config.BASE_Middle_API +
                        'VoucherCreate/Z5CheckErrorBasicDatas',
                    confirmData
                )
                    .then(function (response) {
                        if (response.result.length > 0) {
                            _this.$refs.voucherCreateStep.failstep1(
                                response.result
                            )
                        } else {
                            _this.$refs.voucherCreateStep.successstep1(
                                totalCount
                            )
                            AjaxHelper.post(_this.saveApi, confirmData)
                                .then(function (response) {
                                    if (response.result.isSuccess) {
                                        _this.$refs.voucherCreateStep.successstep2()
                                    } else {
                                        _this.$refs.voucherCreateStep.failstep2(
                                            response.result.voucherHandleInfos
                                        )
                                    }
                                    _this.targetData = []
                                })
                                .catch(function (error) {
                                    _this.$refs.voucherCreateStep.failstep2(
                                        error.message
                                    )
                                })
                        }
                    })
                    .catch(function (error) {
                        _this.$refs.voucherCreateStep.errorstep1(error.message)
                    })
            }
        },
        voucherCreate() {
            if (this.voucherQueryModel.groupType == '') {
                this.$message({
                    type: 'error',
                    message: '请选择凭证生成方式',
                    position: 'bottom-right'
                })
                return false
            }
        },
        getAccount() {
            const _this = this
            this.openloadingHandler()
            AjaxHelper.get(
                _this.VoucherCreateApi +
                    '/GetAccountBooks?brandId=' +
                    _this.voucherQueryModel.brandId
            )
                .then(function (response) {
                    if (response.success) {
                        _this.accountList = response.result
                        _this.voucherQueryModel.account =
                            _this.accountList[0].number
                    }
                    _this.closeloadingHandler()
                })
                .catch(function (error) {
                    _this.closeloadingHandler()
                })
        },
        getTableData(d) {
            const _this = this
            _this.tableData = d
            //查询无结果 不允许生成凭证
            if (d.length > 0) {
                _this.isSearchVal = true
            } else {
                _this.isSearchVal = false
            }
            if (_this.selOrder.length) {
                _this.selOrder.forEach((item) => {
                    if (item.key == _this.$refs.refPagerBar.currentPage) {
                        _this.toggleSelection(item.value)
                    }
                })
            }
            _this.closeloadingHandler()
        },
        orderTypeChange(val) {
            if (this.voucherQueryModel.brandId == '') {
                this.storeSel = false
            } else {
                this.storeSel = true
            }
            this.tableData = []
            this.$refs.refPagerBar.pagerTotal = 0
        },
        accountChange(val) {},
        brandChange(val) {
            this.getOrgList()
            this.getOrderTypes()
            this.brandSel = true
            this.isSearchVal = false
            if (this.voucherQueryModel.orderType == '') {
                this.storeSel = false
            } else {
                this.storeSel = true
            }
            var brandInfo = this.brands.filter((x) => x.id == val)[0]
            this.isMultiOrg = brandInfo.isMutilOrg
            this.voucherQueryModel.store = ''
            this.voucherQueryModel.orderType = ''
            this.storesList = this.stores.filter(
                (x) => x.brandID === this.voucherQueryModel.brandId
            )
        },
        statusSearch(item) {
            this.storeSel = false
            this.brandSel = false
            this.CurrnetMID = item.id
            this.voucherQueryModel.brandId = ''
            this.voucherQueryModel.orderType = ''
            this.brandList = this.brands.filter((x) => x.moduleID == item.id)
            this.isSearchVal = false
        },
        getOrderTypes() {
            const _this = this
            _this.openloadingHandler()
            AjaxHelper.get(
                _this.VoucherCreateApi +
                    '/GetZ5CloudOrderTypes?brandId=' +
                    _this.voucherQueryModel.brandId
            )
                .then(function (response) {
                    if (response.success) {
                        _this.ordersList = response.result
                    }
                    _this.closeloadingHandler()
                })
                .catch(function (error) {
                    _this.closeloadingHandler()
                })
        },
        getModules() {
            const _this = this
            this.openloadingHandler()
            AjaxHelper.get(
                _this.VoucherCreateApi + '/GetModules?tabType=' + _this.tabType
            )
                .then(function (response) {
                    if (response.success) {
                        _this.moduleList = response.result.modules
                        if (_this.moduleList.length > 0) {
                            const firstItem = _this.moduleList[0]
                            _this.CurrnetMID = firstItem.id
                            _this.brands = response.result.brands
                            _this.stores = response.result.stores
                            // _this.brandList = response.result.brands.filter(
                            //   x => x.moduleID == firstItem.id
                            // );
                            _this.brands.forEach((x) => {
                                _this.moduleList.forEach((element) => {
                                    if (element.id == x.moduleID) {
                                        // x.name = element.name + "/" + x.name;
                                        _this.brandList.push(x)
                                    }
                                })
                            })
                        }
                    }
                    _this.closeloadingHandler()
                })
                .catch(function (error) {
                    _this.closeloadingHandler()
                })
        },
        pickerOptions2() {},
        initData() {},

        handleClose(done) {
            this.isVoucherCreate = false
            done()
        }
    }
}
</script>

<style scoped>
.toggletable .el-select,
.toggletable .el-input,
.toggletable .myshowup {
    display: none;
    margin-right: 5px;
}

.toggletable .current-row .myshowup + .el-select {
    display: inline-block;
}
.toggletable .current-row .el-select {
    display: block;
}
.toggletable .current-row .el-input {
    display: block;
}
.toggletable .current-row .myshowup.el-button {
    display: inline-block;
}
.toggletable .current-row .el-select + span {
    display: none;
}
.toggletable .current-row .el-input + span {
    display: none;
}
.current-row .toggleColumn .el-select {
    display: block !important;
    width: 100%;
}
.current-row .toggleColumn .el-input {
    display: block !important;
    width: 100%;
}
.current-row .toggleColumn span {
    display: none;
}
.minicard {
    height: auto !important;
    display: block;
    width: 200px;
    position: absolute;
    right: 0;
    z-index: 9989;
    top: 80px;
}
.minicard .el-button {
    width: 150px;
    margin: 5px 0;
}
.el-dialog__body {
    padding: 10px 15px !important;
}

dl.loglist p {
    font-weight: 600;
    margin: 20px 0 10px 0;
}
dl.loglist dd {
    padding: 15px 0;
    color: #999999;
    display: block;
}
dl,
dt,
dd {
    margin: 0;
    padding: 0;
}
.w25 {
    width: 25%;
    float: left;
}
.w75 {
    width: 75%;
    float: left;
}
.el-card {
    border: 0;
    height: calc(100vh - 225px) !important;
    overflow-y: auto;
}
.padding7 {
    padding: 7px;
}
.top5 {
    padding: 5px 0 0 0;
}
.top7 {
    padding: 7px 0 0 0;
}
</style>
